import { FormattedMessage, useIntl } from 'react-intl';
import { Stack, SxProps, Typography } from '@mui/material';

import { FC } from 'react';
import Head from 'next/head';
import ImageBoxFuture from './image-box-future';
import { MUIResponsiveValue } from '@/logic/types';

interface EmptyStateProps {
  title: string;
  img: string;
  imgWidth?: MUIResponsiveValue<string | number>;
  imgHeight?: MUIResponsiveValue<string | number>;
  headTitle?: string;
  sx?: SxProps;
  titleSx?: SxProps;
}

export const EmptyState: FC<EmptyStateProps> = ({
  title,
  img,
  imgWidth,
  imgHeight,
  headTitle,
  sx,
  titleSx,
}) => {
  const intl = useIntl();

  return (
    <>
      {headTitle && (
        <Head>
          <title>{intl.formatMessage({ id: headTitle })}</title>
        </Head>
      )}
      <Stack
        sx={{
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          ...sx,
        }}
      >
        <ImageBoxFuture
          img={img}
          title={intl.formatMessage({
            id: 'alt.empty_icon',
          })}
          objectFit='contain'
          sx={{
            width: imgWidth,
            height: imgHeight,
          }}
        />

        <Typography
          component='h2'
          sx={{
            ...titleSx,
          }}
        >
          <FormattedMessage id={title} />
        </Typography>
      </Stack>
    </>
  );
};
